// extracted by mini-css-extract-plugin
export default {"wrap":"UserCountPill_wrap__qs78j","current":"UserCountPill_current__rWVa-","max":"UserCountPill_max__uVzhz"};